export default "__VITE_ASSET__DTy2B9sq__"